import { useQueryLoader } from "react-relay"
import { graphql } from "relay-runtime"
import {
  useAgentSkillsQuery,
  useAgentSkillsQuery$data,
} from "@/modules/admin/agent-skills/services/__generated__/useAgentSkillsQuery.graphql"
import { ExtractNode } from "@/modules/patients/types/ExtractNode"

const agentSkillsQuery = graphql`
  query useAgentSkillsQuery {
    doctors {
      edges {
        node {
          gender
          id
          performancePerSlot
          userName
          preferredLanguage
          languages {
            fullySpottable
            skill
          }
          specialties {
            fullySpottable
            skill
          }
          licensesInCountries {
            country
            isFavoredInCountry
          }
          teams {
            fullySpottable
            skill
          }
        }
      }
    }
  }
`

const useAgentSkillsQueryLoader = () => {
  return useQueryLoader<useAgentSkillsQuery>(agentSkillsQuery)
}

export { agentSkillsQuery, useAgentSkillsQueryLoader }
export type AgentSkillsQueryResult = ExtractNode<useAgentSkillsQuery$data["doctors"]>
